import { authedApiInstance } from '../../../firebase';

export function editImage({ boardId, elementId, prompt }: { boardId: string; elementId: string; prompt: string }) {
  authedApiInstance.post(`/room/${boardId}/elements/${elementId}/remix-ai`, { prompt });
}
